import { Summary } from '../models/summary.models';

export const SummaryLevelZeroMocks: Summary = {
  level: '0',
  title: 'LIFETIME MILES FLOWN',
  description: 'Lifetime Miles Flown',
  value: '750,000',
  action: {
    label: 'Learn More',
    url: '/us/en/skymiles/medallion-program/million-miler',
    id: 'learnMore'
  },
  ariaLabels: {
    level: 'graphic level 0 logo million miler',
    title: '750,000 LIFETIME MILES FLOWN'
  },
  disabled: false,
  loaded: true
};

export const SummaryEmptyLevelMocks: Summary = {
  level: '',
  title: 'LIFETIME MILES FLOWN',
  description: 'Lifetime Miles Flown',
  value: '740,000',
  action: {
    label: 'Learn More',
    url: '/us/en/skymiles/medallion-program/million-miler',
    id: 'learnMore'
  },
  ariaLabels: {
    level: 'graphic level  logo million miler',
    title: '740,000 LIFETIME MILES FLOWN'
  },
  disabled: false,
  loaded: true
};

export const SummaryLevelTwoMocks: Summary = {
  level: '2',
  title: 'LIFETIME MILES FLOWN',
  description: 'Lifetime Miles Flown',
  value: '1,100,000',
  action: {
    label: 'Learn More',
    url: '/us/en/skymiles/medallion-program/million-miler',
    id: 'learnMore'
  },
  ariaLabels: {
    level: 'graphic level 2 logo million miler',
    title: '1,100,000 LIFETIME MILES FLOWN'
  },
  disabled: false,
  loaded: true
};

export const SummaryMilesAvailableMocks: Summary = {
  title: 'MILES AVAILABLE',
  description: 'Use these miles for Award Travel and other redemptions.',
  value: '38,000',
  action: {
    id: 'skymilesLandingPageSummaryBookWithMiles',
    label: 'Book with Miles',
    url: '/flight-search/book-a-flight?action=searchFlights&tripType=ROUND_TRIP&awardTravel=true&paxCount=1'
  },
  ariaLabels: { title: '38,000 MILES AVAILABLE' },
  disabled: false,
  loaded: true
};

export const SummaryNoMilesAvailableMocks: Summary = {
  title: 'MILES AVAILABLE',
  description: 'Use these miles for Award Travel and other redemptions.',
  value: '0',
  action: {
    id: 'skyMilesOverviewBookFlight',
    label: 'Book A Trip',
    url: '/flight-search/book-a-flight'
  },
  ariaLabels: { title: '0 MILES AVAILABLE' },
  disabled: false,
  loaded: true
};
